import styled from 'styled-components'
import { sc } from 'utils'
import copy from 'copy.json'

type Props = {
  secondary?: boolean
  sold?: boolean
  draft?: boolean
  published?: boolean
  info?: boolean
  offer?: boolean
  small?: boolean
  user?: boolean
}

const featureStyles = 'border: none; border-radius: 4px; padding: 4px 8px;'

export default styled.div<Props>`
  display: flex;
  flex: none;
  align-items: center;
  gap: 10px;

  width: fit-content;
  padding: 1px 8px;

  border: 1px solid;
  border-radius: 8px;

  font: var(--700-16);
  color: var(--white);
  word-break: break-all;

  ${sc('small', 'padding: 2px 8px; border: none; font: var(--600-12);')}
  ${sc('secondary', 'color: var(--green); border: none; background: var(--white);')}
  ${sc('info', 'background: var(--green);')}
  ${sc('sold', 'background: var(--blue);')}
  ${sc('draft', 'background: var(--yellow); color: var(--dark-gray);')}
  ${sc('published', 'background: var(--white); color: var(--dark-gray);')}
  ${sc('offer', `background: var(--dark-gray); font: var(--400-13); ${featureStyles}`)}
  ${sc(
    'user',
    `background: var(--very-light-green); font: var(--600-16); color: var(--dark-gray); ${featureStyles}`
  )}

  &:empty::before {
    content: '${copy.common.no_value}';
  }
`
